import React from 'react';
import AdminMarkdownDoc from '@/modules/admin/components/AdminMarkdownDoc';
import connectivityMarkdown from '../../../../docs/connectivity-checklist.md?raw';

export default function AdminAppConnectivityPage() {
  return (
    <AdminMarkdownDoc
      icon="🔗"
      title="Making an App Connectable"
      description="For builders: checklist for adding API keys, webhooks, magic links, and integration support to your app"
      subtitle={<>Dashboard links for Upstash Redis and Hookdeck Outpost can be found on the <span className="font-medium text-gray-500">Settings</span> tab.</>}
      markdown={connectivityMarkdown}
    />
  );
}
